import { Box, Alert, Button, Link, Paper, Stack, Typography } from '@mui/material';
import { useBookingFlowContext } from '../../../booking-flow/BookingFlowProvider';
import type { TransferFlowState } from '../flowConfig';

export function TransferFinalizeStep() {
  const flow = useBookingFlowContext<TransferFlowState>();
  const booking = flow.state.cart?.transferBookings?.[0];
  const continueUrl = flow.state.paymentResponse?.continueUrl;

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="subtitle1" gutterBottom>
        Kesinleştirme
      </Typography>
      <Stack spacing={1} sx={{ mb: 2 }}>
        <Typography variant="body2">Referans No: {booking?.referenceNumber ?? '—'}</Typography>
        <Typography variant="body2">Durum: {booking?.status ?? '—'}</Typography>
      </Stack>
      {continueUrl && (
        <Alert severity="info" sx={{ mb: 2 }}>
          Ödeme sağlayıcısı ek doğrulama istiyor:{' '}
          <Link href={continueUrl} target="_blank" rel="noopener noreferrer">
            devam etmek için tıklayın
          </Link>
          .
        </Alert>
      )}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button variant="contained" disabled={flow.status === 'running'} onClick={() => flow.runStep()}>
          {flow.status === 'running' ? 'İşleniyor…' : 'Kesinleştir'}
        </Button>
      </Box>
    </Paper>
  );
}
